import {APK_AUTH_TOKEN_KEY} from './apkApi';

export const getApkToken = () => localStorage.getItem(APK_AUTH_TOKEN_KEY);

export const setApkToken = (token) =>
  localStorage.setItem(APK_AUTH_TOKEN_KEY, token);

export const clearApkToken = () =>
  localStorage.removeItem(APK_AUTH_TOKEN_KEY);

export const isApkAuthenticated = () => Boolean(getApkToken());
